<template>
  <div style="margin-top: 30px; height: 100%; width: 100%; text-align: center">
    <div class="card mb-2 custom-card">
        <div class="card-header d-flex">
            <span class="mr-3 w-25 text-left">Time</span>
            <span>Lucky Numbers</span>
        </div>
        <ul class="list-group list-group-flush text-left">
            <li class="list-group-item d-flex" v-for="(record, index) in numbersGenerated" v-bind:key="index">
                <small class="mr-3 text-muted w-25">{{ record.time }}: </small>
                <span>
                    <span class="badge badge-secondary mr-1 lucky-numbers" v-for="(number, numberIndex) in record.numbers" v-bind:key="numberIndex">{{ number }}</span>
                </span>
            </li>
        </ul>
    </div>
    <div>
        <span class="btn btn-success w-100" v-show="showLoading">
            <img src="/dist/lding_stampede_1s_32px.gif" />
        </span>
        <a name="" id="" class="btn btn-success w-100" href="#" role="button" @click="getLuckyNumbers()" v-show="!showLoading">LUCK</a>
    </div>
  </div>
</template>
<script type="text/babel">
  import NumbersList from './numbers-list.vue';
  import { mapState, mapActions } from 'vuex'
  import { NumbersModel } from '../models/numbers';

  export default {
        data() {
            return {
                numbersGenerated: [],
                id: 0,
                code: 0,
                showLoading: false
            }
        },
        computed: mapState(['numbers']),
        created: function () {
            console.log('Component has been created!');
            //console.dir(this.numbers);
            //this.onGetNumbers();
            //var id = this.$route.params.id;
            //this.$store.dispatch('getNumbers', {type: 'daily', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
            //this.$store.dispatch('getNumbers', {type: 'weekly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
            //this.$store.dispatch('getNumbers', {type: 'monthly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});
            //this.$store.dispatch('getNumbers', {type: 'yearly', id: this.$route.params.id}).then(resp => { /* do someting */ }).catch(err => { console.log(err)});

            //console.log(this.$route.params.id);

            this.id = this.$route.params.id
            this.code = this.$route.params.code

            NumbersModel.generateLuckyNumbersHistory(this.$route.params.id, this.$route.params.code).then(resp => {
                console.log(resp)
                this.numbersGenerated = resp.data.lucky_numbers
            })
            .catch(err => {
                console.log('Errrr: ' + err)
            })
        },
        methods: {
            getLuckyNumbers() {

                this.showLoading = true
                NumbersModel.generateLuckyNumbers(this.id, this.code).then(resp => {
                    //console.log(resp)
                    this.showLoading = false

                    if (Object.keys(resp.data.lucky_numbers.numbers).length) {
                        if (this.numbersGenerated.length >= 7) {
                            this.numbersGenerated.pop()
                        }

                        this.numbersGenerated.unshift(resp.data.lucky_numbers)
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.showLoading = false
                })
            }
        },
        components: {
            'app-numbers-list':NumbersList
        }
    }
</script>
<style scoped>

hr {
	margin-top: 10px;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/getlucky.vue